type RuleDeemedSupplierData = {
  threshold: number;
  countriesFrom: string;
  countriesTo: string;
  sellersLabel: string;
  exceptCountriesFrom: string;
  [key: string]: any;
};

export const transformData = (data: RuleDeemedSupplierData) => {

  return {
    ...data,
    countriesFrom: Array.isArray(data.countriesFrom)
      ? data.countriesFrom
      : data.countriesFrom.split(",").map((country: string) => country.trim()),
    countriesTo: Array.isArray(data.countriesTo)
      ? data.countriesTo
      : data.countriesTo.split(",").map((country: string) => country.trim()),
    exceptCountriesFrom: Array.isArray(data.exceptCountriesFrom)
      ? data.exceptCountriesFrom
      : data.exceptCountriesFrom
          .split(",")
          .map((seller: string) => seller.trim()),
  };
};
